import { z } from "zod";
import { destinatarioDoExtratoSchema } from "./extrato";

/** "fulano@gmail.com" → "f***@gmail.com": para e-mail de conta, que o laboratório não cadastrou. */
export function mascararEmail(email: string) {
  const [nome, dominio] = email.split("@");
  if (!nome || !dominio) return "***";
  return `${nome[0]}***@${dominio}`;
}

export const ORIGENS_DO_EMAIL = ["COBRANCA", "CADASTRO", "CONTA"] as const;
export type OrigemDoEmail = (typeof ORIGENS_DO_EMAIL)[number];

export const MAX_DO_LOTE_DE_EXTRATOS = 300;

export const fecharEEnviarSchema = z
  .object({
    emitir: z.array(destinatarioDoExtratoSchema).max(MAX_DO_LOTE_DE_EXTRATOS),
    enviar: z.array(z.string().min(1)).max(MAX_DO_LOTE_DE_EXTRATOS),
  })
  .refine((v) => v.emitir.length + v.enviar.length > 0, "Escolha ao menos um extrato")
  .refine((v) => v.emitir.length + v.enviar.length <= MAX_DO_LOTE_DE_EXTRATOS, `No máximo ${MAX_DO_LOTE_DE_EXTRATOS} por vez`);
export type FecharEEnviarInput = z.infer<typeof fecharEEnviarSchema>;

export const extratoPorIdSchema = z.object({ extratoId: z.string().min(1) });
